import { styled } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { InputError, InputWrapper, TextInputExtended } from 'src/components';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { OneFormState } from 'src/types';
import { SelectExtended } from '../SelectExtended';

const arrCountries = [
	{
		name: 'ES',
		code: 'ES',
		regex: [
			/\d{4}[b-df-hj-npr-tv-zB-DF-HJ-NPR-TV-Z]{3}/,
			/[A-Za-z]{1,2}\d{4}[A-Za-z]{1,2}/,
		],
		errorMessage: 'Ejemplo: 0000BCD o AA0000AA',
	},
	{
		name: 'DE',
		code: 'DE',
		regex: [/[a-zA-Z]{2,5}\d{1,4}/],
		errorMessage: 'Ejemplo: AAABB0000',
	},
	{
		name: 'FR',
		code: 'FR',
		regex: [
			/[a-hj-np-tv-zA-HJ-NP-TV-Z]{2}\d{3}[a-hj-np-tv-zA-HJ-NP-TV-Z]{2}/,
			/\d{2,4}[a-zA-Z]{2,3}\d{2,3}/,
			/\d{2,4}[a-zA-Z]{2,3}\d{1}(a|b|A|B)/,
		],
		errorMessage: 'Ejemplo: AA000AA o 00000AA00',
	},
	{
		name: 'GB',
		code: 'GB',
		regex: [/[a-zA-Z]{1,2}\d{2}[a-zA-Z]{3}/, /[a-zA-Z]{1}\d{3}[a-zA-Z]{3}/],
		errorMessage: 'Ejemplo: AA00AAA',
	},
	{
		name: 'IT',
		code: 'IT',
		regex: [/[a-zA-Z]{2}\d{3}[a-zA-Z]{2}/],
		errorMessage: 'Ejemplo: AA000AA',
	},
	{
		name: 'PT',
		code: 'PT',
		regex: [/[a-zA-Z]{2}\d{2}[a-zA-Z]{2}/, /\d{2}[a-zA-Z]{2}\d{2}/],
		errorMessage: 'Ejemplo: AA00AA',
	},
	{
		name: 'Otros',
		code: 'Otros',
		regex: [/[a-zA-Z\d\s]{3,}/],
		errorMessage: 'Solo números, letras y espacios',
	},
];

const CountryWrapper = styled.div`
	margin-right: 24px;
	width: 100px;
	float: left;
`;
const MatriculaWrapper = styled.div`
	width: calc(100% - 124px);
	float: left;
`;

const InputErrorWrapper = styled.div`
	&.matricula-error-wrapper {
		p {
			max-width: 179px;
			@media all and (min-width: 560px) {
				max-width: 163px;
			}
			@media all and (min-width: 960px) {
				max-width: 176px;
			}
		}
	}
`;

export function Matricula() {
	const { register, errors } = useFormContext();
	const dispatch = useDispatch();
	const { error, setError } = useOneFormContext();
	const [inputValueMatricula, setInputValueMatricula] = useState('');
	const [errorMatricula, setErrorMatricula] = useState(false);
	const [errorCountry, setErrorCountry] = useState(false);
	const [country, setCountry] = useState<string>('ES');
	const [countryObject, setCountryObject] = useState(null);
	const [regExCounty, setRegExCounty] = useState<RegExp[]>(null);

	const { formInfo, formData } = useSelector((state: OneFormState) => state);

	useEffect(() => {
		if (formData.fields.countryPlate) {
			setCountry(formData.fields.countryPlate);
			const countryObject = arrCountries.find(
				c => c.name === formData.fields.countryPlate,
			);
			setCountryObject(countryObject);
			setRegExCounty(countryObject.regex);
		} else {
			setCountry('ES');
			setCountryObject(arrCountries[0]);
			setRegExCounty(arrCountries[0].regex);
		}
		if (formData.fields.matricula) {
			setInputValueMatricula(formData.fields.matricula);
		}
	}, []);

	const validateMatricula = (input: string) => {
		const isValid = regExCounty.some(regEx => regEx.test(input));

		if (isValid) {
			setErrorMatricula(false);
			return true;
		} else {
			setErrorMatricula(true);
			return false;
		}
	};

	const handleChangeCountry = (event: any) => {
		setCountry(event.currentTarget.value);
		const countryObject = arrCountries.find(
			c => c.name === event.currentTarget.value,
		);
		setCountryObject(countryObject);
		setRegExCounty(countryObject.regex);
		if (countryObject.name !== '') setErrorCountry(false);
		else
			dispatch({
				type: 'UPDATE_FIELDS',
				payload: { ['countryPlate']: countryObject.name },
			});
	};

	const handleChangeMatricula = (e: any) => {
		setInputValueMatricula(e.target.value);
		dispatch({
			type: 'UPDATE_FIELDS',
			payload: { ['matricula']: e.target.value },
		});
	};

	useEffect(() => {
		if (!errorMatricula && !errorMatricula) setError(false);
	}, [errorMatricula, errorMatricula]);

	return (
		<InputWrapper
			className="country_matricula-input-wrapper"
			notALayer={formInfo.notALayer}
		>
			<CountryWrapper>
				<SelectExtended
					name="countryPlate"
					label="País"
					value={country}
					required
					options={arrCountries}
					handleChange={handleChangeCountry}
					onClick={() => null}
					updateFields
					setOption={setCountry}
					isRequired={true}
				/>
			</CountryWrapper>
			<MatriculaWrapper>
				<TextInputExtended
					name="matricula"
					label="Matrícula"
					type="text"
					innerRef={register({
						validate: input => validateMatricula(input),
						required: {
							value: true,
							message: 'Requerido',
						},
						maxLength: 100,
					})}
					isFloating
					onChange={e => handleChangeMatricula(e)}
					required
				/>
				{errorMatricula && (
					<InputErrorWrapper className="matricula-error-wrapper">
						<InputError className="input-error">
							{countryObject.errorMessage}
						</InputError>
					</InputErrorWrapper>
				)}
			</MatriculaWrapper>
		</InputWrapper>
	);
}
